import { http } from '@/api/http';

export const adminLogfileEndpoints = {
  /**
   * GET /system/logfile/{serviceId}?tailBytes=N — read the last N bytes of a service's log
   * file off the shared volume. Returns plain text; the FE is responsible for trimming
   * a possibly-truncated first line.
   */
  getServiceLogTail: (
    serviceId: string,
    tailBytes: number,
    options?: { signal?: AbortSignal },
  ): Promise<string> =>
    http.get<string>(`/system/logfile/${encodeURIComponent(serviceId)}`, {
      ...options,
      query: { tailBytes },
      responseType: 'text',
      // BE controller `produces = text/plain`; without this header the http
      // wrapper sends `Accept: application/json` and the server returns 406.
      headers: { Accept: 'text/plain' },
    }),
};
